import type { User } from "@/types/auth";
import { normalizeStrategyNames } from "@/config/strategyBrokers";

type StrategySource = {
  selectedStrategies?: string[];
  selectedStrategy?: string;
  Strategy_Optimus?: string | null;
  Strategy_Polaris_Lite?: string | null;
  Strategy_Pledge_Plus?: string | null;
  Strategy_Pledge_Plus_Mini?: string | null;
};

/** Parse enrolled strategies from user row (sync-user already returns these columns). */
export function strategiesFromUser(
  user: StrategySource | User | null | undefined
): string[] {
  if (!user) return [];

  if (user.selectedStrategies?.length) {
    return [...user.selectedStrategies];
  }

  const source = user as StrategySource;
  const enrolled: string[] = [];
  
  if (source.Strategy_Optimus) enrolled.push("Optimus");
  if (source.Strategy_Polaris_Lite) enrolled.push("Polaris Lite");
  if (source.Strategy_Pledge_Plus) enrolled.push("Pledge+");
  if (source.Strategy_Pledge_Plus_Mini) enrolled.push("Pledge+ Mini");

  if (enrolled.length > 0) {
    return enrolled;
  }

  if (user.selectedStrategy?.trim()) {
    return user.selectedStrategy
      .split(",")
      .map((part: string) => part.trim())
      .filter(Boolean);
  }

  return [];
}

export function normalizedStrategiesFromUser(
  user: StrategySource | User | null | undefined
) {
  return normalizeStrategyNames(strategiesFromUser(user));
}
